export function useHelpers() {
  const map_status_percepcao = {
    sem_comportamento: '0. Sem Comportamento',
    primeira_compra: '1. Primeira Compra',
    percepcao_em_ruptura: '2. Percepção em Ruptura',
    percepcao_em_ponto_de_pedido: '3. Percepção em Ponto de Pedido',
    percepcao_com_elevada_prematuridade: '4. Percepção com Elevada Prematuridade',
    percepcao_com_elevada_exposicao_ruptura: '5. Percepção com Elevada Exposição Ruptura',
  };

  return {
    map_status_percepcao
  };
}
